import { TextInput } from '@startlibs/form'
import React, { useEffect, useRef } from 'react'
import { IntakeFormCard } from './PatientDetailsNew';
import { isMobile, smoothScroll } from '@startlibs/utils';

export const CaseReconciliationNew = ({ title, subTitle, scrollTo, NavigationButtons }) => {

  const headerRef = useRef()
    
  useEffect(() => {
    if (scrollTo) {
      smoothScroll({ target: headerRef.current, offset: -200 })
    }
  }, [])
  isMobile();

  return <>
    <IntakeFormCard>
      <div>
        {title && <h3 ref={headerRef}>{title}</h3>}
        {subTitle && <p>{subTitle}</p>}
        {/* <p>Insert the information below to export this case to your EHR system</p> */}
        <>
          <TextInput
            label="Medical Record Number"
            helpText="(Patient Identification Number)"
            path="caseInfo.ehrInfo.mrn"
            maxLength={255}
          />
          <TextInput
            label="Order Number"
            path="caseInfo.ehrInfo.orderNumber"
            maxLength={255}
          />
        </>
      </div>
      <NavigationButtons />
    </IntakeFormCard>
  </>
}